var render = function render(){var _vm=this,_c=_vm._self._c;return _c('students',{attrs:{"modalIn":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }